// ============================================================
// ADMIN: Edit the template below to change the default share message.
// Available variables:
//   {dayName}       - e.g. "الاثنين"
//   {gregorianDate} - e.g. "24 فبراير 2026"
//   {hijriDate}     - e.g. "26 شعبان 1447"
// ============================================================
export const DEFAULT_SHARE_TEMPLATE =
`*تم تأكيد الحجز* ✅

📅 *اليوم:* {dayName}
🗓️ *الميلادي:* {gregorianDate}
🌙 *الهجري:* {hijriDate}`;

// Arabic day and month names
const ARABIC_DAYS = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];

const ARABIC_MONTHS = [
  'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
  'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
];

// Return just the Arabic day name for a YYYY-MM-DD date string
// e.g. "الاثنين"
export function toDayName(dateStr) {
  const clean = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr;
  const [year, month, day] = clean.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return ARABIC_DAYS[date.getDay()];
}

// Convert a YYYY-MM-DD date string to an Arabic Gregorian string (no day name)
// e.g. "24 فبراير 2026"
export function toGregorianArabic(dateStr) {
  const clean = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr;
  const [year, month, day] = clean.split('-').map(Number);
  return `${day} ${ARABIC_MONTHS[month - 1]} ${year} م`;
}

// Convert a YYYY-MM-DD date string to a Hijri date string using the browser's Intl API
export function toHijriDate(dateStr) {
  const clean = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr;
  const [year, month, day] = clean.split('-').map(Number);
  // Use local Date constructor to avoid UTC midnight timezone issues
  const date = new Date(year, month - 1, day);
  try {
    return new Intl.DateTimeFormat('ar-SA-u-ca-islamic-umalqura', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  } catch {
    return dateStr;
  }
}

// Replace template placeholders with actual values
export function buildShareMessage(template, { dayName, gregorianDate, hijriDate, note = '' }) {
  return template
    .replace('{dayName}', dayName)
    .replace('{gregorianDate}', gregorianDate)
    .replace('{hijriDate}', hijriDate)
    .replace('{note}', note);
}

// Build a Google Calendar event URL for a booking (all-day event)
export function buildGoogleCalendarUrl({ date, calendarName, guestName, note = '' }) {
  const [year, month, day] = date.split('-').map(Number);
  const pad = (n) => String(n).padStart(2, '0');
  const startDate = `${year}${pad(month)}${pad(day)}`;
  const next = new Date(year, month - 1, day + 1);
  const endDate = `${next.getFullYear()}${pad(next.getMonth() + 1)}${pad(next.getDate())}`;
  const title = note ? `${calendarName} - ${note}` : calendarName;
  const details = [`الاسم: ${guestName}`, note ? `المناسبة: ${note}` : ''].filter(Boolean).join('\n');
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title,
    dates: `${startDate}/${endDate}`,
    details: details
  });
  return `https://www.google.com/calendar/render?${params.toString()}`;
}

// Open WhatsApp with the given message
export function openWhatsApp(message) {
  const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}
